export default __webpack_public_path__ + "static/own-your-error-ada69b728b841e3eb1639d0d0280c478.jpg";